import './PageContent.scss'

import React from 'react';
import PropTypes from 'prop-types';

export default class PageContent extends React.Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        return (
            <main className={`c-page-content ${this.props.className || ''}`}>
                {this.props.children}
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PageContent/index.js